import type { ApiClient } from '../../api/client';
import type { OperationsHomePort } from '../../features/home/public';

export function createOperationsHomeHttpAdapter(client: ApiClient): OperationsHomePort {
  return {
    async loadSummary() {
      const summary = await client.getDashboardSummary();
      return {
        currentHeadcount: summary.currentHeadcount,
        businessProcesses: { openSteps: summary.businessProcesses.openSteps },
      };
    },
    async loadWorkerCount() {
      return (await client.listWorkers()).total;
    },
    async loadOrganizationCount() {
      return (await client.listSupervisoryOrganizations()).total;
    },
    async loadCompanyCount() {
      return (await client.getCompanySummary()).activeCompanyCount;
    },
    async loadPendingInboxCount() {
      return (await client.listInbox()).total;
    },
    downloadWorkerReport() {
      return client.downloadWorkerReport();
    },
  };
}
